import { ControlledTextInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

export const PledgeAddressFlat: FC<IFieldFactoryProps> = ({ type, isDisabled, ...props }) => {
  const validate = useValidateOnBlur(type);

  return (
    <ControlledTextInput
      {...props}
      name={type}
      type="text"
      required={false}
      onBlur={validate}
      disabled={isDisabled}
    />
  );
};
